import { CountingMethod } from '../counting-method/counting-methods';
import { TSimplePolygon } from './coordinate-polygons';
import { TPlussedValuesExportMode, TValueMode } from './export.interface';

export const exportLocationModes = ['predefined-area', 'custom-area', 'tows'] as const;
export type TExportLocationMode = (typeof exportLocationModes)[number];

export type IExportFilter = {
  fromDate?: Date;
  toDate?: Date;
  cprTaxonIds?: number[];
  locationMode?: TExportLocationMode;
  geoCodes?: TGeoAreaCode[];
  polygon?: TSimplePolygon;
  towSearchTerms?: string[];
  countingMethods?: CountingMethod[];
  includeUnfinalised?: boolean;
  valueMode: TValueMode;
  plussedValuesExportMode?: TPlussedValuesExportMode;
  spreadDate?: boolean;
  includeSunParameters?: boolean;
  includePCIValues?: boolean;
};

export type TExportType = 'sample' | 'measurement' | 'monthly-average';

export const geoAreas = {
  a01: 'A01',
  a06: 'A06',
  a08: 'A08',
  b01: 'B01',
  b02: 'B02',
  b04: 'B04',
  b05: 'B05',
  b06: 'B06',
  b07: 'B07',
  b08: 'B08',
  c01: 'C01',
  c02: 'C02',
  c03: 'C03',
  c04: 'C04',
  c05: 'C05',
  c06: 'C06',
  c07: 'C07',
  c08: 'C08',
  d01: 'D01',
  d02: 'D02',
  d03: 'D03',
  d04: 'D04',
  d05: 'D05',
  d06: 'D06',
  d07: 'D07',
  d08: 'D08',
  d09: 'D09',
  e04: 'E04',
  e05: 'E05',
  e06: 'E06',
  e07: 'E07',
  e08: 'E08',
  e09: 'E09',
  e10: 'E10',
  f04: 'F04',
  f05: 'F05',
  f06: 'F06',
  f07: 'F07',
  f08: 'F08',
  f09: 'F09',
  f10: 'F10',
} as const;

export const geoCodes = Object.entries(geoAreas).map((o) => o[0]) as TGeoAreaCode[];

export type TGeoAreaCode = keyof typeof geoAreas;
